import { render, staticRenderFns } from "./ProductModelAddEdit.vue?vue&type=template&id=8402eeb0&scoped=true&"
import script from "./ProductModelAddEdit.vue?vue&type=script&lang=js&"
export * from "./ProductModelAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductModelAddEdit.vue?vue&type=style&index=0&id=8402eeb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8402eeb0",
  null
  
)

export default component.exports